export default __webpack_public_path__ + "static/media/Pelita Std-Bold.7bfec7dd.otf";